<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth > 750">
      <div class="log-box">
        <img src="@/assets/logo.png" alt="">
        <span>สินเชื่อที่จริงใจ</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">หน้าแรก</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">ความแข็งแกร่งของเรา</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">ขั้นตอนการใช้งาน</div>
        <!-- <div @click="choiceMenu(3)" :class="(menuIndex===3)?'choice':''">Información sobre nosotros</div> -->
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">เกี่ยวกับเรา</div>
        <div @click="choiceMenu(5)" :class="(menuIndex === 5) ? 'choice' : ''">นโยบายความเป็นส่วนตัว</div>
        <div @click="choiceMenu(6)" :class="(menuIndex === 6) ? 'choice' : ''">ติดต่อเรา</div>
      </div>
    </div>
    <div class="banner-box" id='home' ref="home">
      <img src="../assets/banner.png" class="banner">
      <div class="app-name">
        <div class="title">สินเชื่อที่จริงใจ</div>
        <div class="content">
          ได้รับเงินกู้ที่เชื่อถือได้
          <br> ปรับปรุงชีวิตของคุณให้ดีขึ้น
        </div>
      </div>
    </div>
    <div class="introduce-box" id='step' ref="step">
      <div class="title">ความแข็งแกร่งของเรา</div>
      <div class="flex-box">
        <img src="../assets/step.png" class="step-img">
        <div class="content">
          <div>ดอกเบี้ยต่ำมาก วงเงินกู้มีหลากหลายรูปแบบ</div>
          <div>ใช้เทคโนโลยีใหม่ล่าสุดเพื่อคัดเลือกผลิตภัณฑ์เงินกู้ที่เชื่อถือได้</div>
          <div>ตรวจสอบคำขอกู้อย่างรวดเร็ว</div>
          <div>ประสบการณ์กู้เงินที่ดี</div>
          <div>ชำระเงินคืนตรงตามกำหนดเวลา ได้รับอันดับเครดิตที่สูงขึ้น</div>
        </div>
      </div>
    </div>

    <div class="introduce-box" id="product" ref="product">
      <div class="title">ขั้นตอนการใช้งาน</div>
      <div class="flex-box">
        <div class="content">
          <div>1.ดาวน์โหลดแอปสินเชื่อที่จริงใจ ใช้หมายเลขโทรศัพท์มือถือเพื่อลงทะเบียนบัญชีส่วนตัวของคุณหลังจากติดตั้งสำเร็จ</div>
          <div>2.เลือกผลิตภัณฑ์เงินกู้ หลังจากยืนยันวงเงินกู้ ระยะเวลากู้และอัตราดอกเบี้ยต่อปี และเริ่มกรอกข้อมูลที่เกี่ยวข้อง</div>
          <div>3.หลังจากกรอกข้อมูลเสร็จเรียบร้อย ก็สามารถยื่นคำขอกู้ได้ การตรวจสอบใช้เวลาไม่นาน</div>
          <div>4.หลังจากได้รับอนุมัติ ก็จะได้รับเงินกู้นี้เลย</div>
        </div>
        <img src="../assets/product.png" class="product-img">
      </div>
    </div>
    <div class="about-us" id='user' ref="user">
      <div class="title">เกี่ยวกับเรา</div>
      <div class="content">
        สินเชื่อที่จริงใจเป็นแพลตฟอร์มกู้ยืมเงินที่ก่อตั้งขึ้นโดยเทคโนโลยีสารสนเทศ สามารถให้บริการเงินกู้ให้ผู้ใช้ชาวไทยที่ดอกเบี้ยค่อนข้างต่ำ วงเงินกู้หลากหลายรูปแบบ และผลิตภัณฑ์เงินกู้ส่วนบุคคลที่น่าเชื่อถือได้ แพลตฟอร์มสินเชื่อที่จริงใจนอกจากให้บริการเงินกู้ที่สะดวกสะบาย ยังช่วยปรับปรุงชีวิตของผู้ใช้จากการให้บริการเงินกู้ที่ปลอดภัยและเชื่อถือได้ โดยใช้เทคโนโลยีการประเมินและตรวจสอบเงินกู้ตามข้อมูลขนาดใหญ่และแบบจำลองเครดิตล่าสุด ผสมกับเทคโนโลยีการจดจำใบหน้าล่าสุด ตรวจสอบการขอกู้เงินอย่างรวดเร็ว ทำให้ผู้ใช้มีประสบการณ์กู้เงินที่ประทับใจ
      </div>
    </div>
    <div class="privacy-box" id='privacy' ref="privacy">
      <div class="content" :class="(isMore) ? '' : 'display'">
        <privacy></privacy>
      </div>
      <div class="get-more" @click="isMore = true" v-if="!isMore">
        <img src="../assets/get-more.png">
      </div>
    </div>

    <div class="del-data-box" id="deletdata" ref="deletdata">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">การใช้ฟังก์ชันการลบข้อมูลเพื่อความปลอดภัยของข้อมูลของคุณ คุณต้องยืนยันตัวตนของคุณ</div>
        <div class="title">กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ</div>
        <input v-model="mobile" type="text" class="tel-in" placeholder="กรุณากรอกหมายเลขโทรศัพท์">
        <input v-model="password" type="password" class="tel-pa" placeholder="กรุณากรอกรหัสผ่านสำหรับแอป">
        <div class="btn" @click="delSearch">ขั้นตอนถัดไป</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="กล่องข้อความ">
          เรียนผู้ใช้
          <br> สวัสดี! ขอบคุณมากครับที่เลือกใช้แอพ สินเชื่อที่จริงใจ
          <br> ก่อนที่จะสมัครลบบัญชี โปรดตรวจสอบให้แน่ใจว่าคำสั่งซื้อของคุณทั้งหมดได้รับการชำระแล้ว และไม่มีคำสั่งซื้อที่อยู่ระหว่างการตรวจสอบ โปรดทราบว่าเมื่อลบบัญชีแล้ว จะไม่สามารถกู้คืนข้อมูลได้ โปรดยืนยันอย่างรอบคอบก่อนใช้งาน แอพนี้ไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดขึ้นต่อทรัพย์สินส่วนบุคคล
          <br> หากคุณยืนยันว่าต้องการลบข้อมูลของคุณ โปรดคลิกปุ่มด้านล่าง
        </div>
        <div class="btn" @click="candelete">ยืนยันการลบ</div>
      </div>

      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">โปรดป้อนรหัสยืนยันเพื่อยืนยันตัวตนของคุณ</div>
        <div class="iump-box">
          <input v-model="code" type="text" class="car-in tel-in" placeholder="กรุณากรอกรหัสยืนยัน 4 หลัก" />
          <div class="count-btn" @click="Reenviar"> {{ 0 >= Time ? 'ส่งอีกครั้ง' : Time }} </div>
        </div>
        <div class="btn" @click="doDelete">ตกลง</div>
      </div>

      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="../assets/del.png" alt="">
        <p>ข้อมูลของคุณถูกลบแล้ว!</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">การยืนยันบัตรประจำตัวประชาชน</div>
        <input v-model="idcard" type="text" class="tel-in" placeholder="กรุณากรอกบัตรประจำตัวประชาชนของคุณ">
        <div class="btn" @click="verifyIdCard">กำลังตรวจสอบ</div>
      </div>
    </div>

    <div class="footer" id='footer' ref="footer">
      <div class="title">ติดต่อเรา </div>
      <div class="flex-footer-content">
        <div class="box">
          <img src="@/assets/mail.png" class="mail-img">
          <div class="text">adameallen8ds@gmail.com </div>
        </div>
        <div class="box">
          <img src="@/assets/address.png" class="mail-img">
          <div class="text">ที่อยู่ติดต่อของเรา อาคารกิมเงิน ชั้น 8 กรุงเทพมหานคร, จังหวัด กรุงเทพมหานคร 10120 </div>
        </div>
      </div>
      <div class="copyright">© Copyright by สินเชื่อที่จริงใจ.</div>
    </div>

    <div class="flex-box-item" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="../assets/title-err.png" class="err-img">
          {{ msg }}
        </div>
        <img src="../assets/close.png" class="close" @click="msgDlg = false">
      </div>
    </div>

  </div>
</template>

<script>
import * as api from "@/api/api";
import privacy from "@/components/privacy";
export default {
  name: 'App',
  components: {
    privacy
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      mobile: '',
      password: '',
      code: '',
      msgDlg: false,
      msg: '',
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: '',
      verifyIDCard: '',
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step").scrollIntoView(); break;
        case 2: document.getElementById("product").scrollIntoView(); break;
        case 3: document.getElementById("user").scrollIntoView(); break;
        case 4: document.getElementById("about").scrollIntoView(); break;
        case 5: document.getElementById("privacy").scrollIntoView(); break;
        case 6: document.getElementById("footer").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    },
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password
      }
      if (!this.mobile) {
        this.msg = 'หมายเลขโทรศัพท์มือถือต้องไม่เว้นว่าง'
        this.msgDlg = true
        return
      }
      if (!this.password) {
        this.msg = 'รหัสผ่านต้องไม่เว้นว่าง'
        this.msgDlg = true
        return
      }

      let loding = this.$loading.show({})
      api.delInfoSearch(data).then(res => {
        loding.hide()
        this.infoData = res.data
        this.steps = 2
      }).catch(e => {
        loding.hide()
        this.msg = e.message
        this.msgDlg = true
      })
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id
      }
      let loding = this.$loading.show({})
      api.delInfoCanDelete(data).then(res => {
        loding.hide()
        if (res.data.idcard) {
          this.verifyIDCard = res.data.idcard
          this.steps = 5
        } else {
          this.steps = 3
          this.Reenviar()
        }
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3
        this.Reenviar()
      } else {
        this.msgDlg = true
        this.msg = 'ป้อนบัตรประจำตัวไม่ถูกต้องและการตรวจสอบล้มเหลว'
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return
      }
      this.Countdown(60)
      let data = {
        mobile: this.mobile
      }
      let loding = this.$loading.show({})
      api.delInfoSms(data).then(res => {
        loding.hide()
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    doDelete() {
      if (!this.code) {
        this.msg = 'ต้องกรอกรหัสยืนยัน'
        this.msgDlg = true
        return
      }
      let loding = this.$loading.show({})
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id
      }
      api.delInfoDoDelete(data).then(res => {
        loding.hide()
        this.steps = 4
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    Countdown(time) {
      this.Time = time
      if (time <= 0) {
        return
      }

      setTimeout(() => {
        this.Countdown(time - 1)
      }, 1000);
    },
    goToPrivacy() {
      this.$router.push({ path: '/Privacy' })
      window.scrollTo(0, 0);
    }
  }
}
</script>


<style lang="less">
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
